import Vue from 'vue'
import Vuex from 'vuex'
import { actionTypes, commitTypes, dbName } from "./store-types";
import systemApi from "./api/systemApi";
import accountApi from "./api/accountApi";

Vue.use(Vuex)

const defaultUser = () => ({
    UserId: null,
    Role: null,
    FullName: null,
    MobileConfirmed: false,
    EmailConfirmed: false,
    AccessToken: null,
    RefreshToken: null,
});

const userProfile = () => ({
    BirthDate: null,
    Mobile: null,
    Email: null,
    UserName: null,
    FirstName: null,
    LastName: null,
    Avater: null,
    Address: null,
    Avatar: null,
    Bio: null,
    CodePostal: null,
    NationalCodeConfirmed: false,
    Organization: null,
    Phone: null,
    Side: null,
    TelPhoneConfirmed: false,
    ProvinceId: 0,
    CityId: 0,
});

const appConfig = () => ({
    AppId: 0,
    Version: 0,
    AppLink: null,
    LastUpdate: null,
    Required: false,
    MainDomain: null,
});

const userDashboard = () => ({
    WalletAmount: 0,
    ProfitAmount: 0,
    TicketCount: 0,
    TicketNewCount: 0,
    TicketTop: null,
    ServiceCount: 0,
    ActiveServiceCount: 0,
    InvoiceCount: 0,
    NewInvoiceCount: 0,
    InvoiceTop: null,
    Packages: null,
    ServiceType: null,
    BankAccounts: null
});

var ticketGroup = () => ({
    Name: null,
    Display: null,
    Tickets: {},
    CountNew: 0
});

export default new Vuex.Store({
    state: {
        sidenav: true,
        user: defaultUser(),
        userProfile: userProfile(),
        signedIn: false,
        loginRedirect: null,
        config: appConfig(),
        province: null,
        notifications: null,
        dashboard: userDashboard(),
        ticketGroups: ticketGroup(),
        services: null,
        serviceType: null,
    },
    getters: {
        sidenav: state => state.sidenav,
        getToken: state => {
            return state.user.AccessToken;
        }
    },
    mutations: {
        [commitTypes.SET_USER](state, user) {
            Object.assign(state.user, user);
            state.signedIn = user.AccessToken !== null;
        },
        [commitTypes.SET_USER_PROFILE](state, userProfile) {
            Object.assign(state.userProfile, userProfile);
        },
        [commitTypes.SET_STATE](state, localState) {
            Object.assign(state, localState);
            state.signedIn = (state.user.AccessToken !== null);
            // console.log("token ", state.user.AccessToken);
        },
        [commitTypes.SET_SETTINGS](state, config) {
            // state.config = config;
            Object.assign(state.config, config);
        },
        [commitTypes.SET_REDIRECT](state, val) {
            state.loginRedirect = val;
        },
        toggleSideNav: (state, value) => {
            if (typeof value === 'boolean') {
                state.sidenav = value;
                return;
            }
            state.sidenav = !state.sidenav;
        }
    },
    actions: {
        toggleSideNav({ commit }, value) {
            commit('toggleSideNav', value)
        },
        // initial data load from the server: paths, config info, lists, keys, etc
        [actionTypes.APP_LOAD]({ commit, state }) {
            return new Promise((resolve, reject) => {
                systemApi.appSettings()
                    .then(({ data }) => {
                        commit(commitTypes.SET_SETTINGS, data);
                        resolve();
                    }).catch((e) => {
                        reject(e);
                    });
            });
        },
        [actionTypes.SAVE_LOGIN]({ commit, state }, authInfo) {
            return new Promise((resolve) => {                
                let redirect = state.loginRedirect ? state.loginRedirect : { name: "Home", params: {} };                
                commit(commitTypes.SET_REDIRECT, null);

                if (!authInfo.MobileConfirmed) {
                    redirect = { name: 'UserConfirm', params: { id: authInfo.UserId } };
                }

                commit(commitTypes.SET_USER, authInfo);

                resolve(redirect);
            });
        },
        [actionTypes.CLEAR_LOGIN]({ commit, state }) {
            console.log("CLEAR_LOGIN");
            commit(commitTypes.SET_STATE, {
                sidenav: true,
                user: defaultUser(),
                userProfile: userProfile(),
                signedIn: false,
                loginRedirect: null,
                config: appConfig(),
                province: null,
                notifications: null,
                dashboard: userDashboard(),
                ticketGroups: ticketGroup(),
                services: null,
                serviceType: null,
            });
            localStorage.setItem(dbName.DB_STATE, state);
            return true; //accountApi.logout();
        },
        [actionTypes.CHECK_TOKEN]({ dispatch, state }) {
            if (state.signedIn) {
                return accountApi.isAuthenticated().then((r) => {
                    // console.log("isAuthenticated", r.data);
                    // console.log(r);
                    if (r.data === true) {
                        return dispatch(actionTypes.SAVE_LOGIN, r.data);
                    } else {
                        return dispatch(actionTypes.CLEAR_LOGIN);
                    }
                }).catch(() => {
                    console.log("step 2");
                    dispatch(actionTypes.CLEAR_LOGIN);
                });
            }
        },
        [actionTypes.LOAD_LOCATION]({ commit, state }) {
            try {
                var localState = JSON.parse(localStorage.getItem(dbName.DB_STATE));
                if (localState && localState.config) {
                    if (localState.config.Version == state.config.Version) {
                        commit(commitTypes.SET_STATE, localState);
                        // console.log("load location", state);
                        // console.log("load location", state.user.AccessToken);
                    }
                }
            }catch(e) {
                console.error(e);
            }
            
            return true;
        },
        [actionTypes.LOAD_USER_DATA]({ commit, state }) {
            if (state.signedIn) {
                accountApi.userProfile()
                    .then(({ data }) => {
                        commit(commitTypes.SET_USER_PROFILE, data);
                    }).catch((e) => {
                        console.error(e);
                    });
            }
            return true; //accountApi.logout();
        },
        [actionTypes.SAVE_DATA]({ commit, state }) {
            return localStorage.setItem(dbName.DB_STATE, JSON.stringify(state));
        },
    }
})